import * as React from "react";
import { createDispatchHook, createSelectorHook, createStoreHook, ReactReduxContextValue } from "react-redux";
import { createSubscription } from "react-redux/es/utils/Subscription";
import { Dispatch, legacy_createStore, Store } from "redux";
import { reducerSetIfChanged } from "services/Helpers";

export interface UseCMSSearchOnClickHandlers {
    onProjectClicked?: (projectId: string) => void;
    onFileClicked?: (projectId: string, fileId: string) => void;
    onShowPreview?: (result: any) => void;
}

export interface UseCMSSearchState {
    onClickHandlers?: UseCMSSearchOnClickHandlers;
}
type UseCMSSearchActions =
    | { type: "setOnClickHandlers", value?: UseCMSSearchOnClickHandlers }
    ;
type UseCMSSearchSelectorType = <TSelected = unknown>(selector: (state: UseCMSSearchState) => TSelected, equalityFn?: ((left: TSelected, right: TSelected) => boolean) | undefined) => TSelected
type UseCMSSearchDispatchType = () => Dispatch<UseCMSSearchActions>;
type UseCMSSearchStoreType = () => Store<UseCMSSearchState, UseCMSSearchActions>

const initStateUseCMSSearch = (): UseCMSSearchState => {
    return {};
}
const reducerUseCMSSearch = (state: UseCMSSearchState = initStateUseCMSSearch(), action: UseCMSSearchActions): UseCMSSearchState => {
    switch (action.type) {
        case "setOnClickHandlers":
            return reducerSetIfChanged(state, "onClickHandlers", action.value);
    }

    return state;
}

export const useCMSSearchStore = legacy_createStore(reducerUseCMSSearch);

export const useCMSSearchContext = React.createContext<ReactReduxContextValue<UseCMSSearchState, UseCMSSearchActions>>({
    store: useCMSSearchStore,
    subscription: createSubscription(useCMSSearchStore)
});

export const useUseCMSSearchStore = createStoreHook(useCMSSearchContext) as UseCMSSearchStoreType;
export const useUseCMSSearchDispatch = createDispatchHook(useCMSSearchContext) as UseCMSSearchDispatchType;
export const useUseCMSSearchSelector = createSelectorHook(useCMSSearchContext) as UseCMSSearchSelectorType;